<template>
  <div>
    <button class="button -primary buy-btn " :class="{'buy-btn-tag': !isSticky}"  @click="ecommercebtn">
      {{ buyOnlinebuttonText }}
    </button>
  </div>
</template>
<script>
import { eventBus } from 'EventBus/';

export default {
  name: 'vch-buy-online-ecommerce-btn',
  props: {
    buttonText: {
      type: String,
      default: '',
    },
    isSticky: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      buyOnlinebuttonText: this.buttonText,
    };
  },
  methods: {
    ecommercebtn() {
      const elements = document.getElementsByClassName('_rfp_mctb_mc_05_');
      if (elements.length > 0) {
        eventBus.$emit('rfp-mctb-enable-popup-direction');
      } else {
        eventBus.$emit('buy-online-ecommerce-event');
      }
    },
  },
  mounted() {
    eventBus.$on('buy-button-text', (event) => {
      this.buyOnlinebuttonText = event;
    })    
  },
};
</script>
